import { isAcceptedType } from '@shared/validators/file-upload-validators';
import { useCallback, useEffect, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button } from '@/components-new/button';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components-new/dialog';
import { ErrorMessage, Field, Label } from '@/components-new/fieldset';
import { FileUpload, FileUploadContainer } from '@/components-new/file-upload';

type AttachmentUploadDialogProps = {
  open: boolean;
  submitting: boolean;
  accept?: string;
  onSubmit: (file: File) => void;
  onClose: () => void;
};

export const AttachmentUploadDialog = ({ open, submitting, accept, onSubmit, onClose }: AttachmentUploadDialogProps) => {
  const {
    control,
    watch,
    formState: { errors, isValid },
    setError,
    handleSubmit,
    reset
  } = useForm<{ file: File }>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'File | unde... Remove this comment to see the full error message
    defaultValues: { file: null }
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => reset(), [open]);

  const fileWatch = watch('file');
  const canSubmit = useMemo(() => fileWatch != null, [fileWatch]);

  const handleFormSubmit = (form: { file: File }) => {
    onSubmit(form.file);
  };

  // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  const validationFnCallback = useCallback(() => isAcceptedType(accept), [accept]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Upload Attachment</DialogTitle>
      <DialogBody>
        <Controller
          control={control}
          name="file"
          rules={{
            required: true,
            validate: (value) => {
              const validationFn = validationFnCallback();
              const result = validationFn(value);

              if (result != null) {
                setError('file', { message: result });
              }

              // @ts-expect-error TS(2345): Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
              setError('file', undefined);
              return result;
            }
          }}
          render={({ field: { onChange, value } }) => (
            <Field>
              <Label>Upload</Label>
              <FileUploadContainer>
                <FileUpload
                  name="file"
                  accept={accept}
                  onChange={(e) => {
                    const files = e.target.files;
                    onChange(files && files.length > 0 ? files[0] : null);
                  }}
                  fileName={(value as unknown as File)?.name ?? undefined}
                />
              </FileUploadContainer>
              {errors.file?.message && <ErrorMessage>{errors.file.message}</ErrorMessage>}
            </Field>
          )}
        />
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>Cancel</Button>
        <Button disabled={!isValid || !canSubmit || submitting} onClick={handleSubmit(handleFormSubmit)}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};
